import httpClient from './httpClient';

const fechasComputoRhService = {
  async obtenerFechas(empresaId) {
    try {
      const response = await httpClient.get(`/fechas-computo-recibo-honorarios/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data || [],
      };
    } catch (error) {
      console.error('Error al obtener fechas de cómputo de recibo por honorarios:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener fechas de cómputo de recibo por honorarios',
        data: [],
      };
    }
  },

  async agregarFecha(empresaId, titulo, diaComputo) {
    try {
      const response = await httpClient.post('/fechas-computo-recibo-honorarios', {
        empresa_id: empresaId,
        titulo,
        dia_computo: diaComputo,
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Fecha guardada exitosamente',
      };
    } catch (error) {
      console.error('Error al agregar fecha de cómputo de recibo por honorarios:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al guardar fecha de cómputo de recibo por honorarios',
      };
    }
  },

  async eliminarFecha(id) {
    try {
      const response = await httpClient.delete(`/fechas-computo-recibo-honorarios/${id}`);
      return {
        success: true,
        message: response.data.message || 'Fecha eliminada exitosamente',
      };
    } catch (error) {
      console.error('Error al eliminar fecha de cómputo de recibo por honorarios:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar fecha de cómputo de recibo por honorarios',
      };
    }
  },
};

export default fechasComputoRhService;

